import { render, staticRenderFns } from "./openRecord.vue?vue&type=template&id=561569da&"
import script from "./openRecord.vue?vue&type=script&lang=js&"
export * from "./openRecord.vue?vue&type=script&lang=js&"
import style0 from "./openRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports